import styled from "@emotion/styled";

import { ellipsise, SkiliticsIcon, Tooltip } from "@skilitics/designer-ui-components";

import type { ConditionBuildable } from "../../types";
import { SidebarDraggable } from "./SidebarDraggable";

type Props = {
  conditionBuildable: ConditionBuildable;
};

export const ConditionDraggable = ({ conditionBuildable }: Props) => {
  const { nodeId, spec, name } = conditionBuildable;

  if (!nodeId) return null;

  return (
    <SidebarDraggable conditionOrEffect="condition" typeId={name} nodeId={nodeId} title={spec?.title}>
      <SkiliticsIcon icon="condition" />
      <Tooltip title={spec?.title} placement="right">
        <Title>{spec?.title}</Title>
      </Tooltip>
    </SidebarDraggable>
  );
};

const Title = styled.span`
  ${ellipsise}
  text-transform: capitalize;
`;
